/**
 * errors.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

/* tslint:disable:max-classes-per-file */

import { Message } from "./message";

export abstract class MessageError extends Error
{
  public request : Message;

  public abstract name : string;

  constructor (public message : string)
  {
    super(message);
  }
}

export class MissingReplyError extends MessageError
{
  public name : string = "Missing Reply Error";

  constructor (public request : Message)
  {
    super("Stream closed before reply");
  }
}

export class ReplyTimeoutError extends MessageError
{
  public name : string = "Reply Timeout Error";

  constructor (public request : Message, public timeout? : number)
  {
    super(
      "Server did not reply within given timeout "
      + (timeout ? "of " + timeout + "ms" : "(unknown)")
    );
  }
}

export class BadReplyError extends MessageError
{
  public name : string = "Bad Reply Error";

  constructor (public request : Message, public response : Message)
  {
    super("Reply failed request's validation");
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/general/errors.ts